"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const eventListenerPool_1 = __importDefault(require("hcore/dist/eventListenerPool"));
class FileInput {
    constructor(id) {
        this.file = null;
        this.id = id;
        this.el = document.getElementById(this.id);
        this.listeners = new eventListenerPool_1.default();
        document.getElementById(this.id).addEventListener('change', (e) => {
            // @ts-ignore
            this.file = e.target.files[0];
            this.listeners.emit(this.file);
        });
    }
    static generate(container = document.body) {
        const el = document.createElement('input');
        el.type = 'file';
        el.id = `${this.prefix}_${this.instances}`;
        this.instances += 1;
        container.appendChild(el);
        return new FileInput(el.id);
    }
    onUpload(handler) {
        this.listeners.listen(handler);
    }
}
exports.default = FileInput;
FileInput.instances = 0;
FileInput.prefix = 'file_input';
